import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Icon from './Icon'

const Logo = ({ extraClass, icon = 'logo' }) => {
  const classes = classnames(extraClass, 'logo')
  return <Icon icon={icon} className={classes} />
}

Logo.propTypes = {
  extraClass: PropTypes.string
}

export default Logo
